import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {axiosBaseQuery} from "../../utils/http"
import {ResponsePermission} from "../../types/Permission"

export const permissionApi = createApi({
    reducerPath: "permissionApi",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["permission"],
    endpoints: build => ({
        getPermissions: build.query<ResponsePermission, void>({
            query: () => ({
                url: `users/self`,
                method: "GET"
            }),
            providesTags: ["permission"]
        })
    })
})

export const {useGetPermissionsQuery} = permissionApi
